// دالة مساعدة لتنسيق الرصيد
export const formatBalance = (value) => {
    if (value === null || value === undefined || value === "") return "—";

    // محاولة تحويل النص لرقم
    const number = parseFloat(value);

    if (isNaN(number)) return "—"; // حماية لو مو رقم
    return new Intl.NumberFormat("en-US").format(number);
  };
